import React, {useEffect, useState} from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import styled from 'styled-components';
import {removeLocalStorageItem, setLocalStorageItem, getLocalStorageItem} from 'e3-common/utils/localStorageUtil';
import {validate} from "e3-common/utils/validationUtil";
import useFetch from "e3-common/hooks/useFetch";
import {useBoundStore} from "e3-common/store/useBoundStore";
import Session from 'react-session-api';
import {useToast} from "e3-common/hooks/useToast";

const Wrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f7f9fc;
`;

const Card = styled.div`
  width: 360px;
  padding: 24px;
  box-shadow: 0 8px 16px rgba(18, 40, 76, 0.09);
  border-radius: 8px;
  background-color: #fff;

  @media (max-width: 480px) {
    width: 90%; /* 모바일에서는 화면 90% 차지 */
    padding: 16px;
  }
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 20px;

  @media (max-width: 480px) {
    font-size: 18px; /* 모바일 글씨 크기 조정 */
  }
`;

const Input = styled.input`
  width: 100%;
  padding: 12px;
  border-radius: 4px;
  border: 1px solid #ddd;
  font-size: 14px;
  margin-bottom: 12px;

  &:focus {
    border-color: #3e86f5;
    outline: none;
  }
`;

const Button = styled.button`
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 4px;
  background-color: #3e86f5;
  color: white;
  font-size: 16px;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    background-color: #336fd1;
  }
`;

const ErrorMsg = styled.div`
  color: #e74c3c;
  font-size: 13px;
  margin-bottom: 10px;
  text-align: center;
`;

const PasswordCheckPage = () => {
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const { request } = useFetch();
    const userId = useBoundStore((state) => state.user.userId);
    const navigate = useNavigate();
    const location = useLocation();
    const {Error, CloseToast} = useToast();


    useEffect(() => {
        Session.get('password-confirmed') === 'true' && navigate(location.state?.from || '/');
        if(!Session.get('password-confirmed') === 'true') Session.clear();
    },[])

    const handleLoginSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!password) {
            setError('비밀번호를 입력해 주세요.');
            return;
        }
        const requestOptions = {
            method: 'POST',
            body: {
                USER_ID: userId,
                PASSWORD: password,
            },
        };
        const messageOptions = {
            showConfirm: false,
            showAlert: false,
        };

        try {
            const param = {USER_ID: userId, PASSWORD: password};
            const response = await request("/login-admin", {method:'POST', body: param}, messageOptions);

            if (response) {
                const isStage = import.meta.env.VITE_PUBLIC_URL !== '';
                Session.set("count", 1024);
                Session.set("password-confirmed", 'true');
                if(isStage){
                    await navigate(normalizeFromPath(location.pathname || location.state?.from));
                }
                else {
                    console.log('location', location);
                    await navigate(import.meta.env.VITE_PUBLIC_URL + location.pathname || location.state?.from )
                }

            } else {
                setError(response.data.message || '비밀번호가 올바르지 않습니다.');
            }
        } catch (error) {
            await setError(error.message);
        }
    };

    const normalizeFromPath = (fromPath) => {
        const publicUrl = import.meta.env.VITE_PUBLIC_URL;

        if (fromPath.startsWith(`/${publicUrl}`) && !!`${publicUrl}`) {
            return fromPath.slice(publicUrl.length + 1);
        }

        return fromPath;
    };


    return (
        <Wrapper>
            <Card>
                <Title>🔒 관리자 인증</Title>
                <form onSubmit={handleLoginSubmit}>
                    {error && <ErrorMsg>{error}</ErrorMsg>}
                    <Input
                        type="password"
                        placeholder="비밀번호를 입력하세요"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <Button type="submit">인증하기</Button>
                </form>
            </Card>
        </Wrapper>
    );
};

export default PasswordCheckPage;